var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunOpen64(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "64px",
    width: "64px",
    id: "_x31_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    stroke: "#000000",
    strokeWidth: 0.00128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x30__1_",
    d: "M115.4,57.9h-14.7C99.6,50.5,97,44.6,93,39.1l10.7-10.7c1.8-1.8,1.8-4.8,0-6.6c-1.8-1.8-4.8-1.8-6.6,0 l-10.7,11c-5.2-4.4-11.4-6.6-18.8-7.7V10.4c0-2.9-1.8-4.8-4.8-4.8c-2.9,0-4.8,1.8-4.8,4.8v14.7c-7.4,1.1-13.3,3.7-18.8,7.7 L28.5,22.2c-1.8-1.8-4.8-1.8-6.6,0c-1.8,1.8-1.8,4.8,0,6.6l10.7,10.7c-4.4,5.2-6.6,11.4-7.7,18.8H10.1c-2.9,0-4.8,1.8-4.8,4.8 c0,2.9,1.8,4.8,4.8,4.8h14.7c1.1,7.4,3.7,13.3,7.7,18.8L21.9,97.3c-1.8,1.8-1.8,4.8,0,6.6c1.1,1.1,2.6,1.5,3.3,1.5s2.6-0.4,3.3-1.5 l10.7-10.7c5.2,4.4,11.4,6.6,18.8,7.7v14.7c0,2.9,1.8,4.8,4.8,4.8c2.9,0,4.8-1.8,4.8-4.8V101c7.4-1.1,13.3-3.7,18.8-7.7L97,103.9 c1.1,1.1,2.6,1.5,3.3,1.5c1.1,0,2.6-0.4,3.3-1.5c1.8-1.8,1.8-4.8,0-6.6L93,86.6c4.4-5.2,6.6-11.4,7.7-18.8h14.7 c2.9,0,4.8-1.8,4.8-4.8C120.2,60.1,118.4,57.9,115.4,57.9z M62.8,33.9c15.8,0,28.7,12.9,28.7,28.7S78.6,91.4,62.8,91.4 S34,78.5,34,62.7S46.9,33.9,62.8,33.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunOpen64);
export default __webpack_public_path__ + "static/media/sunOpen64.05b5803365ae02504a639d477ec23f4d.svg";
export { ForwardRef as ReactComponent };